// ==================================================================================================
//
// Profile Goals Donut Chart with D3
//
// ==================================================================================================
import * as d3 from "d3";
import {getCheckins, updateMember} from '../utilities'

const donutWorkoutChart = () => {
  let props = {
    height: 125,
    width: 125,
    radius: 0,
    donutThickness: 7,
    workoutsThisWeek: 0,
    data: []
  };

  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.wrapper = '#js-donut-workout-chart'
    els.$workoutGoalInput = $('.js-workout-goal-input')
    els.$workoutsThisWeek = $('.js-workouts-this-week')
    els.$workoutGoal = $('.js-workout-goal')
    els.$goalForm = $('#goal-form')
    els.svg = null
    els.pie = null
    els.arc = null
    els.slices = null
    els.doneCircle = null
    return;
  }

  // Update donut with new data values
  // ------------------------------------------------
  const updateDonutWithNewData = () => {
    els.slices.data(els.pie(props.data))
    els.slices.transition().duration(750)
      .attrTween('d', function(a) {
        // Store the displayed angles in this._current and interpolate values
        const i = d3.interpolate(this._current, a);
        this._current = i(0);
        return function(t) {
          return els.arc(i(t));
        };
      }
    )

    updateInnerDonut()
  }

  // Update complete inner circle donut fill
  // ------------------------------------------------
  const updateInnerDonut = () => {
    const circleRadius = props.radius - (props.donutThickness/2)

    if (props.data[0] >= 100) {
      els.doneCircle.transition().duration(750)
        .ease(d3.easeExp)
        .attr('r', circleRadius)
    } else {
      els.doneCircle.transition().duration(750)
        .attr('r', 0)
    }
  }

  // Calculate percentages for donut chart
  // ------------------------------------------------
  const calculateGoal = (workoutGoal) => {
    calculateNewData(workoutGoal)
    updateDonutWithNewData()
  }

  // Grab new goal from workout select
  // ------------------------------------------------
  const updateGoal = (e) => {
    const newGoal = parseInt(e.currentTarget.value)

    els.$workoutGoal.text(newGoal)
    els.$workoutGoal.attr('data-workout-goal', newGoal)

    calculateGoal(newGoal)

    updateMember(els.$goalForm)
  }

  // Setup donut
  // ------------------------------------------------
  const setUpDonutChart = (data) => {
    props.radius = Math.min(props.width, props.height) / 2

    const circleRadius = props.radius - (props.donutThickness/2)

    els.pie = d3.pie()
                .sort(null)

    els.arc = d3.arc()
                .innerRadius(props.radius)
                .outerRadius(props.radius - props.donutThickness)

    els.svg = d3.select(els.wrapper)
                .append("svg")
                .attr("width", props.width)
                .attr("height", props.height)
                .append("g")
                .attr("transform", "translate(" + props.width / 2 + "," + props.height / 2 + ")");

    els.svg.append('circle')
      .attr('r', circleRadius)
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('stroke', '#d8d8d8')
      .attr('stroke-width', props.donutThickness)
      .attr('fill', 'none');

    els.doneCircle = els.svg.append('circle')
      .attr('r', props.data[0] >= 100 ? circleRadius : 0)
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('fill', '#28a9ec');

    els.slices = els.svg.selectAll('path')
      .data(els.pie(props.data))
      .enter().append('path')
      .attr('fill', (d, i) => i > 0 ? 'transparent' : '#28a9ec')
      .attr('d', els.arc)
      .each(function(d) { this._current = d })
  }

  // Calculate new data after goal change
  // ------------------------------------------------
  const calculateNewData = (newGoal) => {
    const percentComplete = Math.round((props.workoutsThisWeek / newGoal) * 100)
    props.data = [percentComplete, 100 - percentComplete]
  }

  // Programmatically set up default workout goal from data fed into view from MMS
  // ------------------------------------------------
  const setUpDefaultWorkoutGoal = () => {
    const lastSetGoal = els.$workoutGoal.attr('data-workout-goal')

    // set currently selected option in input to last set goal
    els.$workoutGoalInput.find('option[value="' + lastSetGoal + '"]').prop('selected', true)
    els.$workoutGoalInput.find('option[value="' + lastSetGoal + '"]').attr('selected','selected')
    els.$workoutGoalInput.val(lastSetGoal)
  }

  // Store data from front end
  // ------------------------------------------------
  const storeData = () => {
    props.workoutsThisWeek = els.$workoutsThisWeek.data('workouts-this-week')
    const workoutGoal = els.$workoutGoal.data('workout-goal')

    setUpDefaultWorkoutGoal()
    calculateNewData(workoutGoal)
    setUpDonutChart(props.data)
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return

    // if svg already exists due to turbolinks, remove it
    if ($(els.wrapper).find('svg').length) $(els.wrapper).empty()

    // then recreate the donut
    storeData()
    els.$workoutGoalInput.on('change', updateGoal)

    props.isEnabled = true
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return

    // Remove your event handlers here
    els.$workoutGoalInput.off('change', updateGoal)

    props.isEnabled = false
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren()
    enable()
  }

  return {
    init,
    enable,
    disable
  };
}

export default donutWorkoutChart;
